import React, { useEffect, useState, useContext  } from "react"
import Flatpickr from "react-flatpickr";

import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Label,
  Input,
  InputGroup,
  Form,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Spinner,
  CardFooter
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik";

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import { CreateCorporateGovernance, GetCorporateGovernanceById, UpdateCorporateGovernance } from "services/api/module/CorporateGovernance"
import ModalContext from "../../contexts/ModalContext";
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang";
import moment from "moment";
import MyEditor from "components/MyEditor";
import UploadFileS3 from "components/UploadFileS3";
import InputAttachment from "components/Input/attachment/InputAttachment";
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import UploadDesc from "components/UploadDesc";
import { ReactSortable } from 'react-sortablejs';
import Sortable from "sortablejs"
import Error401 from "components/Error401";

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE
const _routePermission = `corporate-governance:corporate-governance`

const CorporateGovernanceTemplate = ({
  pageView = "create"
}) => {
  // POPUP
  const { mAlert } = useContext(ModalContext);

  // OTHER STATE
  const qParams = useParams()
  const qLang = _.upperCase(qParams?.lang) ?? 'TH'
  const qMainId = 1
  const navigate = useNavigate();


  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    contentSection1: Yup.string().required("Please Enter Section 1"),
    contentSection2: Yup.string().required("Please Enter Section 2"),

    // contentSeoTitle: Yup.string().required("Please Enter Meta Title"),
    // contentSeoKeyword: Yup.string().max(1024).required("Please Enter Meta keyword"),
    // contentSeoDescription: Yup.string().max(1024).required("Please Enter Meta Description"),
    contentUpdateDate: Yup.string().max(100).required("Please Select Written at"),
    contentStatus: Yup.string().max(100).required("Please Enter Display"),


  })
  

  // LOCAL STATE FORM
  const [updatedValidationSchema, setUpdatedValidationSchema] = useState(validationSchema)

  const initialValues = {
    contentId: "",

    // Content
    contentSection1: "",
    // contentDetail: "",
    contentSection2: "",
    contentThumbnailS1: {},
    contentThumbnailS2: {},

    contentSeoTitle: "",
    contentSeoKeyword: "",
    contentSeoDescription: "",
    contentUpdateDate: moment().format('YYYY-MM-DD'),
    contentStatus: "active",


  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: updatedValidationSchema,
    onSubmit: values => {
      console.log("🚀 ~ CorporateGovernanceCreate ~ values:", values)
      const payload = {
        id: qMainId ? qMainId : undefined,
        contentId: values.contentId ? values.contentId: undefined,
        langId: qLang,
        contentSection1: values.contentSection1,
        // contentDetail: values.contentDetail,
        contentSection2: values.contentSection2,

        contentSeoTitle: values.contentSeoTitle,
        contentSeoKeyword: values.contentSeoKeyword,
        contentSeoDescription: values.contentSeoDescription,
        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,

        attachmentData: {

        },

        contentAttachmentData: {
          thumbnailS1: values.contentThumbnailS1,
          thumbnailS2: values.contentThumbnailS2,
        }
      };
      console.log("🚀 ~ onSave ~ payload:", payload);

      if (pageView === "update") {
        API.fetchUpdateCorporateGovernance(payload)
      } else {
        API.fetchCreateCorporateGovernance(payload)
      }
    },
  })

  const preFilInput = (resData = {}) => {
    console.log("🚀 ~ preFilInput ~ resData:", resData)
    // resetForm(validation.values, initialValues)

    // ถ้าไม่หน่วงมันจะแย่งกันทำ
    validation.setFieldValue("contentId", resData?.contentId ?? "")
    validation.setFieldValue("contentSection1", resData?.contentSection1 ?? "")
    validation.setFieldValue("contentSection2", resData?.contentSection2 ?? "")
    validation.setFieldValue("contentThumbnailS1", resData?.contentThumbnailS1 ?? "")
    validation.setFieldValue("contentThumbnailS2", resData?.contentThumbnailS2 ?? "")
    
    validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
    validation.setFieldValue("contentSeoKeyword", resData?.contentSeoKeyword ?? "")
    validation.setFieldValue("contentSeoDescription", resData?.contentSeoDescription ?? "")
    validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format('YYYY-MM-DD'))
    validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")

  }

  const API = {
    fetchGetCorporateGovernanceById: async (payload) => {
      try {
          const response = await GetCorporateGovernanceById({ id: payload.id, lang: qLang })
          const resData = response.data
          if (resData.status == 200) {
            preFilInput(resData.data)
          }
      }
      catch (err) {
          console.log('err ', err)
          mAlert.info({
            title: "Alert",
            subTitle: "Something went wrong",
            content: "",
            onClose: () => {
            //  alert("onClose")
            },
        })
      }
    },
    fetchCreateCorporateGovernance: async (payload) => {
      try {
          const response = await CreateCorporateGovernance({ data: payload, lang: qLang })
          const resData = response.data
          if (resData.status == 201) {
            mAlert.info({
                title: "Alert",
                subTitle: "Created Data Success",
                content: "",
                onClose: () => {
                  navigate(`/corporate-governance/${qLang}/edit`)
                },
            })
          }
      } catch (e) {
          console.log(e)
          mAlert.info({
              title: "Alert",
              subTitle: "Something went wrong",
              content: "",
              onClose: () => {
              //  alert("onClose")
              },
          })
      }
    },
    fetchUpdateCorporateGovernance: async (payload) => {
      try {
          const response = await UpdateCorporateGovernance({ data: payload, id: payload.id, lang: qLang })
          const resData = response.data
          if (resData.status == 202) {
              mAlert.info({
                  title: "Alert",
                  subTitle: "Update Data Success",
                  content: "",
                  onClose: () => {
                    navigate(`/corporate-governance/${qLang}/edit`)
                  },
              })
          }
      }
      catch (err) {
          console.log('err ', err)
          mAlert.info({
              title: "Alert",
              subTitle: "Something went wrong",
              content: "",
              onClose: () => {
              //  alert("onClose")
              },
          })
      }
    }
  }

  // กรณี Edit
  useEffect(() => {
    if (["update", "view"].includes(pageView)) {
      const payload = { id : qMainId }
      API.fetchGetCorporateGovernanceById(payload)
    }
  }, [qLang])

  const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
  document.title = `Coporate Governance | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

  const itemStyle = {
    padding: '10px',
    border: '1px solid black',
    margin: '5px',
    borderRadius: '8px',
    background: '#f9f9f9',
    transition: 'transform 0.2s ease, background-color 0.3s ease',
  };

  const mapValues = (list = []) => list.map(item => {
    const newObj = {
      attachmentId: item.attachmentId,
      sequence: item.sequence
    }
    return newObj
  })

  if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
    return <Error401 />
  }
  
  return (
      <React.Fragment>
          <div className="page-content">
            <Container fluid>
                {/* Render Breadcrumb */}
                <Breadcrumbs
                  title={`${PAGE_VIEW} Coporate Governance`}
                  breadcrumbItems={[
                    { title: "Coporate Governance", link: "" },
                    { title: PAGE_VIEW },
                  ]}
                />
    
                {/* Render Form */}
                <Row>
                  <Col className="col-12">
                  <FormikProvider value={validation}>
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                      }}
                    >
                      <Row>
                          <Col className="col-8">
                            <Card>
                              <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                <i className='bx bx-cube-alt'></i> Information Box
                              </h5>
                              <CardBody>
                              <Row>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    Section 1
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <MyEditor
                                      onChange={(event, editor) => {
                                        const data = editor.getData()
                                        validation.setFieldValue("contentSection1", data)
                                      }}
                                      value={validation.values.contentSection1}
                                      isError={validation.touched.contentSection1 && validation.errors.contentSection1 ? true : false}
                                      disabled={pageView === "view"}
                                    />
                                    { 
                                      validation.touched.contentSection1 && validation.errors.contentSection1 && (
                                        <div type="invalid"className="invalid-feedback d-block">
                                          {validation.errors.contentSection1}
                                        </div>
                                      )
                                    }
                                  </div>
                                </Col>
                                
                                <Col className="col-12 mb-3">
                                {/* {JSON.stringify(validation.values.contentThumbnailS1)} */}
                                  <div className="col-md-12">
                                    <PopupAttachment
                                      typeDetail="single"
                                      typeUpload="ImageMap"
                                      upload="Image"
                                      prefixName="brand-image"
                                      label="Thumbnail Section 1"
                                      required={false}
                                      description="description"
                                      widthSize={740}
                                      heightSize={500}
                                      value={validation.values.contentThumbnailS1}
                                      onChange={(value = {}, index) => {
                                        console.log("🚀 onChange ~ value:", value)
                                        console.log("🚀 onChange ~ index:", index)
                                        validation.setFieldValue('contentThumbnailS1', value)
                                      }}
                                      onRemove={(index) => {
                                        console.log("🚀 onChange ~ index:", index)
                                        validation.setFieldValue('contentThumbnailS1', {})
                                      }}
                                    />
                                    {validation.touched.contentThumbnailS1 && validation.errors.contentThumbnailS1 && (
                                      <div type="invalid"className="invalid-feedback d-block">
                                        {validation.errors.contentThumbnailS1}
                                      </div>
                                    )}
                                  </div>
                                  <hr/>
                                </Col>
                                
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    Section 2
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <MyEditor
                                      onChange={(event, editor) => {
                                        const data = editor.getData()
                                        validation.setFieldValue("contentSection2", data)
                                      }}
                                      value={validation.values.contentSection2}
                                      isError={validation.touched.contentSection2 && validation.errors.contentSection2 ? true : false}
                                      disabled={pageView === "view"}
                                    />
                                    { 
                                      validation.touched.contentSection2 && validation.errors.contentSection2 && (
                                        <div type="invalid"className="invalid-feedback d-block">
                                          {validation.errors.contentSection2}
                                        </div>
                                      )
                                    }
                                  </div>
                                </Col>

                                <Col className="col-12 mb-3">
                                {/* {JSON.stringify(validation.values.contentThumbnailS2)} */}
                                  <div className="col-md-12">
                                    <PopupAttachment
                                      typeDetail="single"
                                      typeUpload="ImageMap"
                                      upload="Image"
                                      prefixName="brand-image"
                                      label="Thumbnail Section 2"
                                      required={false}
                                      description="description"
                                      widthSize={700}
                                      heightSize={500}
                                      value={validation.values.contentThumbnailS2}
                                      onChange={(value = {}, index) => {
                                        console.log("🚀 onChange ~ value:", value)
                                        console.log("🚀 onChange ~ index:", index)
                                        validation.setFieldValue('contentThumbnailS2', value)
                                      }}
                                      onRemove={(index) => {
                                        console.log("🚀 onChange ~ index:", index)
                                        validation.setFieldValue('contentThumbnailS2', {})
                                      }}
                                    />
                                    {validation.touched.contentThumbnailS2 && validation.errors.contentThumbnailS2 && (
                                      <div type="invalid"className="invalid-feedback d-block">
                                        {validation.errors.contentThumbnailS2}
                                      </div>
                                    )}
                                  </div>
                                  <hr/>
                                </Col>
                                
                              </Row>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col className="col-4">
                            <Card outline color="primary" className="border sticky-element">
                                <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                  <i className='bx bx-check'></i> Tools Box
                                </h5>
                                <CardBody>
                                  <Row>
                                    <Col className="col-12 mb-3">
                                      <label
                                        htmlFor="category_name"
                                        className="col-md-12 col-form-label"
                                      >
                                        Switch Language
                                        <span className="t-require">*</span>
                                      </label>
                                      <div className="col-md-12">
                                        <InputLang widthfull pageView={pageView} forceRoute={false}/>
                                      </div>
                                    </Col>
                                    <Col className="col-12 mb-3">
                                      <label
                                        htmlFor="category_name"
                                        className="col-md-12 col-form-label"
                                      >
                                        Written at
                                        <span className="t-require">*</span>
                                      </label>
                                      <div className="col-md-12">
                                        <InputGroup>
                                          <Flatpickr
                                            className="form-control d-block"
                                            options={{
                                              dateFormat: 'd/m/Y', // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                            }}
                                            value={validation.values.contentUpdateDate  ?moment(validation.values.contentUpdateDate, 'YYYY-MM-DD').toDate() : null}
                                            disabled={true}
                                          />
                                          <div className="input-group-append">
                                            <button
                                              type="button"
                                              className="btn btn-outline-secondary docs-datepicker-trigger"
                                              disabled
                                            >
                                              <i className="fa fa-calendar" aria-hidden="true"/>
                                            </button>
                                          </div>
                                        </InputGroup>
                                        {
                                          (validation.touched.contentUpdateDate && validation.errors.contentUpdateDate) && (
                                            <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentUpdateDate}</div>
                                          )
                                        }
                                      </div>
                                    </Col>
                                    <Col className="col-12 mb-3">
                                      <label
                                        htmlFor="category_name"
                                        className="col-md-12 col-form-label"
                                      >
                                        Display
                                        <span className="t-require">*</span>
                                      </label>
                                      <div className="col-md-12">
                                        <Select
                                          placeholder="Select Status"
                                          value={fn_helper.FNFORM.getObjectValue(STATUS_OPTION, `${validation.values.contentStatus}`)}
                                          onChange={(value) => validation.setFieldValue("contentStatus", value.id)}
                                          getOptionValue={(option) => option.id}
                                          getOptionLabel={(option) => option.name}
                                          options={STATUS_OPTION}
                                          className={`select2-selection ${validation.touched.contentStatus && validation.errors.contentStatus ? "input-err" : ""}` }
                                          isDisabled={pageView === "view"}
                                        />
                                        {
                                          (validation.touched.contentStatus && validation.errors.contentStatus) && (
                                            <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentStatus}</div>
                                          )
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </CardBody>
                                <CardFooter>
                                  <Row>
                                      {/* <Col className="text-start">
                                          <Button color="danger" className="btn btn-danger" onClick={() => navigate(`/corporate-governance/${qLang}`)}>Back</Button> 
                                      </Col> */}
                                      <Col className="text-end">
                                        {pageView !== 'view' && (<Button type="submit" className="btn btn-success">Save</Button>)}
                                      </Col>
                                  </Row>
                                </CardFooter>
                            </Card>
                          </Col>
                          {
                            false && (
<Col className="col-12">
                            <Card>
                                <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                    <i className='bx bx-trending-up'></i> SEO Box
                                </h5>
                                <CardBody>
                                <Row className="">
                                  <Col className="col-12 mb-3">
                                    <label
                                      htmlFor="category_name"
                                      className="col-md-12 col-form-label"
                                    >
                                      Meta Title
                                      <span className="t-require">*</span>
                                    </label>
                                    <div className="col-md-12">
                                      <Input
                                        id="contentSeoTitle"
                                        className="form-control"
                                        type="text"
                                        placeholder="Page Title"
                                        name="contentSeoTitle"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.contentSeoTitle}
                                        invalid={validation.touched.contentSeoTitle && validation.errors.contentSeoTitle ? true : false}
                                        disabled={pageView === "view"}
                                      />
                                      { 
                                        validation.touched.contentSeoTitle && validation.errors.contentSeoTitle && (
                                          <FormFeedback type="invalid">
                                            {validation.errors.contentSeoTitle}
                                          </FormFeedback>
                                        )
                                      }
                                    </div>
                                  </Col>
                                  <Col className="col-12 mb-3">
                                    <label
                                      htmlFor="category_name"
                                      className="col-md-12 col-form-label"
                                    >
                                      Meta Description
                                      {/* <span className="t-require">*</span> */}
                                    </label>
                                    <div className="col-md-12">
                                      <Input
                                        id="contentSeoDescription"
                                        className="form-control"
                                        type="text"
                                        placeholder="SEO Description"
                                        name="contentSeoDescription"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.contentSeoDescription}
                                        invalid={validation.touched.contentSeoDescription && validation.errors.contentSeoDescription ? true : false}
                                        disabled={pageView === "view"}
                                      />
                                      { 
                                        validation.touched.contentSeoDescription && validation.errors.contentSeoDescription && (
                                          <FormFeedback type="invalid">
                                            {validation.errors.contentSeoDescription}
                                          </FormFeedback>
                                        )
                                      }
                                    </div>
                                  </Col>
                                  <Col className="col-12 mb-3">
                                    <label
                                      htmlFor="category_name"
                                      className="col-md-12 col-form-label"
                                    >
                                      Meta Keywords
                                      {/* <span className="t-require">*</span> */}
                                    </label>
                                    <div className="col-md-12">
                                      <Input
                                        id="contentSeoKeyword"
                                        className="form-control"
                                        type="text"
                                        placeholder="SEO Keywords"
                                        name="contentSeoKeyword"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.contentSeoKeyword}
                                        invalid={validation.touched.contentSeoKeyword && validation.errors.contentSeoKeyword ? true : false}
                                        disabled={pageView === "view"}
                                      />
                                      { 
                                        validation.touched.contentSeoKeyword && validation.errors.contentSeoKeyword && (
                                          <FormFeedback type="invalid">
                                            {validation.errors.contentSeoKeyword}
                                          </FormFeedback>
                                        )
                                      }
                                    </div>
                                  </Col>

                                </Row>
                                </CardBody>
                            </Card>
                          </Col>
                            )
                          }
                          
                      </Row>
                    </Form>
                  </FormikProvider>
                  </Col>
                </Row>
            </Container>
          </div>
      </React.Fragment>
  )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(CorporateGovernanceTemplate)
